
$(document).ready(function () {
 $('.header nav a').on('click', function (e) {
  e.preventDefault();

  let target = $(this).attr('href');
  let $target = $(target);

  if (!$target.length) return;

  $('.header nav a').removeClass('active');
  $(this).addClass('active');

  $('html, body').stop(true, false).animate({
   scrollTop: $target.offset().top
  }, {
   duration: 1000,
   easing: 'easeInOutCubic',
   queue: false
  });
 });
});